import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import ResponseEmpty_vue_vue_type_script_setup_true_lang_default from "./ResponseEmpty.vue.script.js";
/* empty css                            */
//#region src/v2/blocks/response-block/components/ResponseEmpty.vue
var ResponseEmpty_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponseEmpty_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-0895623d"]]);
//#endregion
export { ResponseEmpty_default as default };

//# sourceMappingURL=ResponseEmpty.vue.js.map